import http from "@/tools/http";

export default {
  getAll(orgUUID, limit) {
    return http.get(`/organizations/${orgUUID}/distributions?limit=${limit}`);
  },
  getByName(orgUUID, text) {
    return http.get(`/organizations/${orgUUID}/distributions?name=${text}`);
  },
  update(orgUUID, payload) {
    return http.patch(
      `/organizations/${orgUUID}/surveys/${payload.survey_uuid}/distributions/${payload.uuid}`,
      payload
    );
  },
  create(orgUUID, surveyUUID, data) {
    return http.post(`/organizations/${orgUUID}/surveys/${surveyUUID}/distributions`, data);
  },
  getDistributionsBySurvey(orgUUID, uuid, pagination) {
    return http.get(`/organizations/${orgUUID}/surveys/${uuid}/distributions`, { params: pagination });
  },
  getAllResend(organizationUUID, surveyUUID, distributionUUID) {
    return http.get(`/organizations/${organizationUUID}/surveys/${surveyUUID}/distribution/${distributionUUID}`);
  },
  delete(organizationUUID, surveyUUID, distributionUUID) {
    return http.delete(`/organizations/${organizationUUID}/surveys/${surveyUUID}/distributions/${distributionUUID}`);
  },
  resend(organizationUUID, surveyUUID, distributionUUID) {
    return http.get(
      `/organizations/${organizationUUID}/surveys/${surveyUUID}/distributions/${distributionUUID}/resend`
    );
  },
  getSegment(orgUUID, surveyUUID, distributionUUID) {
    return http.get(`/organizations/${orgUUID}/surveys/${surveyUUID}/distributions/${distributionUUID}/segment`);
  },
  getLinkList(orgUUID, surveyUUID, distributionUUID) {
    return http.get(`/organizations/${orgUUID}/surveys/${surveyUUID}/distributions/${distributionUUID}/download`);
  },
  getCustomersByDistribution(orgUUID, surveyUUID, distributionUUID, pagination) {
    return http.get(`/organizations/${orgUUID}/surveys/${surveyUUID}/distributions/${distributionUUID}/customers`, {
      params: pagination
    });
  }
};
